import { useCallback, useState } from "react";

import InputMask from "../InputMask";
import http from "infra/http";
import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { showErrorAxios } from "infra/helpers/alerta";
import { formatCNPJ } from "@brazilian-utils/brazilian-utils";

export interface CnpjResponse {
  pessoa: {
    nome: string;
    documento: string;
    telefone?: string;
    celular?: string;
    imagemUrl?: string;
    nomeFantasia?: string;
    inscricaoEstadual?: string;
    inscricaoMunicipal?: string;
    cnaeId?: string | undefined;
    naturezaJuridicaId?: string;
    classificacaoTributariaId?: string;
    email?: string;
  };
  endereco: {
    estadoId: string;
    cidadeId: string;
    bairro: string;
    logradouro: string;
    complemento: string;
    cep: string;
    numero: string;
    observacao: string;
  } | null;
}

interface InputCnpjProps {
  value: any;
  onChange: (val: any) => any;
  onLoadCnpj: (data: CnpjResponse) => any;
}
function InputCnpj({
  value,
  onChange,
  onLoadCnpj,
  ...props
}: InputCnpjProps & Record<string, any>) {
  const [isLoading, setIsLoading] = useState(false);

  const handleCnpj = useCallback(async () => {
    if (!value) {
      return;
    }
    try {
      setIsLoading(true);

      const { data } = await http.get(
        `/v1/bots/cnpj/${value.replace(/[^0-9]/g, "")}`
      );

      onLoadCnpj(data);
    } catch (error) {
      showErrorAxios(error);
    } finally {
      setIsLoading(false);
    }
  }, [onLoadCnpj, value]);

  return (
    <Box pos="relative">
      {props.readonly ? (
        <Box mt="10px" pb="4px" fontSize={"16px"}>
          {formatCNPJ(value)}
        </Box>
      ) : null}

      {!props.readonly ? (
        <InputMask
          mask="99.999.999/9999-99"
          value={value}
          onChange={(v) => {
            onChange(v);
          }}
          onKeyDown={(ev) => {
            if (ev.keyCode === 13 && typeof onLoadCnpj === "function") {
              handleCnpj();
            }
          }}
          {...props}
        />
      ) : null}
      {!props.readonly ? (
        <Button
          isLoading={isLoading}
          disabled={isLoading || props.disabled}
          position="absolute"
          right="4px"
          colorScheme="blue"
          bottom="3.5px"
          size="sm"
          bg={colors.primary}
          color={colors.white}
          _hover={{
            bg: colors.primaryDark,
          }}
          onClick={() => {
            if (typeof handleCnpj === "function") {
              handleCnpj();
            }
          }}
        >
          {isLoading ? null : "Buscar"}
        </Button>
      ) : null}
    </Box>
  );
}

export default InputCnpj;
